import StatisticsCard, { VariationType } from "./statisticsCard"
export type { VariationType }
export default StatisticsCard